import { updateObject } from 'utils/updateObject'
import {
  SET_ACCOUNT_CONNECT_MANUAL,
  SET_NETWORK_PAYMENT_ACCOUNTS,
  SET_NETWORK_SETTINGS,
  SET_YANDEX_USERS,
} from 'modules/Services/types'

const initialState = {
  paymentProfiles: [],
  loading: true,
  settings: null,
  connectManualLoading: true,
  connectManualText: {},
  yandexUsers: {},
}

const setNetworkPaymentAccounts = (state, { payload }) =>
  updateObject(state, {
    loading: false,
    paymentProfiles: payload,
  })

const setNetworkSettings = (state, { payload }) =>
  updateObject(state, {
    settings: payload,
  })

const setYandexUsers = (state, { payload }) =>
  updateObject(state, {
    yandexUsers: { ...state.yandexUsers, ...payload },
  })

const setAccountCreateManual = (state, { payload }) =>
  updateObject(state, {
    ...payload,
  })

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NETWORK_PAYMENT_ACCOUNTS:
      return setNetworkPaymentAccounts(state, action)
    case SET_NETWORK_SETTINGS:
      return setNetworkSettings(state, action)
    case SET_YANDEX_USERS:
      return setYandexUsers(state, action)
    case SET_ACCOUNT_CONNECT_MANUAL:
      return setAccountCreateManual(state, action)
    default:
      return state
  }
}
